import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export const FormServerError = ({ errorText }) => {
  if (errorText) {
    return (
      <ErrorStyles>
        <i className="cc-icon-red fa fa-exclamation-circle"></i> {errorText}
      </ErrorStyles>
    );
  }

  return null;
};

FormServerError.propTypes = {
  errorText: PropTypes.string,
};

const ErrorStyles = styled.div`
  color: var(--thunderbird);
  background-color: var(--cinderella);
  border-bottom: 1px solid var(--thunderbird);
  margin: -10px -10px 10px;
  padding: 10px;
  white-space: pre-line;
`;
